import React from "react";
import { Select } from "react-input-textboxs";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core/";
import { DataGrid } from "@material-ui/data-grid";
import * as XLSX from "xlsx";

const columns = [
  // { field: "id", headerName: "ID", width: 150, sortable: false },
  {
    field: "keywords",
    headerName: "Keywords",
    width: 150,
    sortable: false,
  },
  {
    field: "language",
    headerName: "Language",
    width: 150,
    sortable: false,
  },
  {
    field: "product",
    headerName: "Product",
    // type: "number",
    width: 110,
    sortable: false,
  },
  {
    field: "recordingCount",
    headerName: "Recording Count",
    // type: "number",
    width: 110,
    sortable: false,
  },
];

const rows = [
  { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
  { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
  { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
  { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
  { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: null },
  { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
  { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
  { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
  { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 },
];

export default function FileUpload(props) {
  const [select, setSelection] = React.useState([]);
  const [showSubmit, setShowSubmit] = React.useState(true);

  const {
    formValue: { file },
    selectedKeywords,
    existingKeywordsList,
  } = props;
  console.log(existingKeywordsList);
  const keywordOptions =
    existingKeywordsList.length > 0
      ? existingKeywordsList.map((ele, i) => {
          return {
            id: i,
            keywords: ele.Keywords,
            language: ele.Language,
            product: ele.Product,
            recordingCount: ele.RecCount,
          };
        })
      : [];
  console.log(keywordOptions);
  const handleRowSelection = (e) => {
    // prints correct indexes of selected rows
    console.log(e);
    const selectedIDs = new Set(e);
    const selectedRows = keywordOptions.filter((row) =>
      selectedIDs.has(row.id)
    );

    // missing the first row selected  setSelection(e.selectionModel);

    setSelection(selectedRows);
    console.log(selectedRows);
  };
  React.useEffect(() => {
    console.log(select);
    props.handleSelectedKeywords(select);
  }, [select]);

 
  const handleUpload = (e) => {
    var value = e.target
    var files = e.target.files, f = files[0];
    var reader = new FileReader();
    reader.onload = function (e) {
        var data = e.target.result;
        let readedData = XLSX.read(data, {type: 'binary'});
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];

        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
        console.log(dataParse[0][0],"dataParse");
        console.log(dataParse[0][1],"dataParse");
        console.log(dataParse[0][2],"dataParse");
        if(dataParse[0][0] === "Keywords" && dataParse[0][1] === "Language" && dataParse[0][2] === "Product"){
          props.handleFileChange(value, "file")
          setShowSubmit(false);
        }
        else{
          alert("Field mismathch")
          setShowSubmit(true);
        }
    };
    reader.readAsBinaryString(f)
}

  return (
    <div className="add-user-model">
      <div className="add-user-wrapper">
        <h2>Upload File</h2>
        <form>
          <div className="inp-fld">
            <input
              type="file"
              accept=".xls,.xlsx,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              onChange={(e) => handleUpload(e)}
            />
            <span style={{color:"red"}}>File must be in .xls/.xlsx/.csv format</span>
          </div>
          <div className="btn-wrapper">
            <button
              className="btn submit-btn"
              disabled={showSubmit}
              onClick={(e) => [e.preventDefault(), props.handleSubmit()]}
            >
              Submit
            </button>
          </div>
          <br />
          <br />
          {keywordOptions.length > 0 && (
            <>
              <FormControl
                component="fieldset"
              >
                <FormLabel component="legend">Select Action</FormLabel>
                <RadioGroup
                  row
                  aria-label="keywords-action"
                  name="keywords-action"
                  onChange={(e) => props.handleKeywordsAction(e.target.value)}
                  defaultValue="0"
                >
                  <FormControlLabel value="0" control={<Radio />} label="Add" />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Replace"
                  />
                </RadioGroup>
              </FormControl>
              <br />
              <br />
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  rows={keywordOptions}
                  columns={columns}
                  pageSize={5}
                  checkboxSelection
                  disableColumnFilter
                  disableColumnMenu
                  disableColumnSelector
                  disableSelectionOnClick
                  onSelectionModelChange={handleRowSelection}
                />
              </div>
              <br />
              <br />
              <div className="btn-wrapper">
                <button
                  className="btn submit-btn"
                  onClick={(e) => [
                    e.preventDefault(),
                    props.handleKeywordsSubmit(),
                  ]}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
